import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ClubDetail from "@/pages/ClubDetail";
import WeeklyCalendar from "@/pages/WeeklyCalendar";

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    window.__lenis = lenis;
  }, [lenis]);
  return null;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
      <LenisBridge />
      <div className="App grain relative" dir="rtl">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Navigate to="/maayanot" replace />} />
            <Route path="/calendar" element={<WeeklyCalendar />} />
            <Route path="/:school" element={<Home />} />
            <Route path="/:school/club/:id" element={<ClubDetail />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
      </div>
    </ReactLenis>
  );
}

export default App;
